import React, { useState, useEffect, Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';

/**
 * App Component
 * Fixed for Premium Black Theme and SEO sync.
 */
function App() {
  // 1. Language State
  const [lang, setLang] = useState('en');
  const isAr = lang === 'ar';

  /**
   * ✅ SYNC HTML ATTRIBUTES & THEME
   * Ensures SEO crawlers and the browser engine recognize the dark theme and language.
   */
  useEffect(() => {
    // Set Direction and Language Code
    document.documentElement.dir = isAr ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;

    // Force Body Background to Black to prevent white "flashes" during navigation
    document.body.style.backgroundColor = '#050505';

    // Smooth Font Transitions
    document.body.style.fontFamily = isAr
      ? "'Noto Sans Arabic', sans-serif"
      : "'Plus Jakarta Sans', sans-serif";
  }, [lang, isAr]);

  // 2. Language Toggle Logic
  const toggleLang = () => {
    const newLang = lang === 'en' ? 'ar' : 'en';
    setLang(newLang);
    localStorage.setItem('preferredLang', newLang);
  };

  // Load saved language on mount
  useEffect(() => {
    const savedLang = localStorage.getItem('preferredLang');
    if (savedLang) setLang(savedLang);
  }, []);

  return (
    <Router>
      {/* 
          Suspense Fallback fixed for Black Theme.
          Prevents the "White Screen of Death" while components load.
      */}
      <Suspense
        fallback={
          <div className='h-screen w-screen flex flex-col items-center justify-center bg-[#050505]'>
            <div className='relative flex items-center justify-center'>
              {/* Outer Pulse Ring */}
              <div className='absolute w-20 h-20 bg-medical-blue-600/20 rounded-full animate-ping'></div>
              {/* Inner Static Logo Placeholder */}
              <div className='relative w-16 h-16 bg-medical-blue-600 rounded-full flex items-center justify-center shadow-lg shadow-medical-blue-600/40'>
                <div className='w-8 h-1 bg-white rounded-full animate-pulse'></div>
              </div>
            </div>
            <div className='mt-8 h-1 w-32 bg-white/5 rounded-full overflow-hidden'>
              <div className='h-full bg-medical-blue-500 animate-[loading_1.5s_infinite] w-1/2'></div>
            </div>
          </div>
        }
      >
        {/* Changed bg-white to bg-[#050505] */}
        <div className='min-h-screen bg-[#050505] text-white selection:bg-medical-blue-500/30'>
          <AppRoutes lang={lang} toggleLang={toggleLang} />
        </div>
      </Suspense>
    </Router>
  );
}

export default App;
